import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Heart } from "lucide-react";
import { BuddhaLogo } from "./BuddhaLogo";
import { useDonate } from "../context/DonateContext";
import { TRUST } from "../data/content";

const NAV = [
  { name: "Home", path: "/", testId: "nav-link-home" },
  { name: "About Us", path: "/about", testId: "nav-link-about" },
  { name: "Gallery", path: "/gallery", testId: "nav-link-gallery" },
  { name: "Events", path: "/events", testId: "nav-link-events" },
  { name: "Documents", path: "/documents", testId: "nav-link-documents" },
  { name: "Contact", path: "/contact", testId: "nav-link-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { openDonate } = useDonate();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200/80 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-brand-home">
            <BuddhaLogo className="h-12 w-12" />
            <div className="leading-tight">
              <p className="font-display font-extrabold text-[15px] sm:text-base text-[#0F2942] max-w-[190px] sm:max-w-none">
                Lord Buddha Awareness
              </p>
              <p className="text-[10px] sm:text-xs tracking-wide text-emerald-700 font-semibold uppercase">
                & Development Foundation
              </p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={item.testId}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  pathname === item.path
                    ? "text-emerald-700 bg-emerald-50"
                    : "text-slate-700 hover:text-emerald-700 hover:bg-slate-50"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={openDonate}
              data-testid="nav-donate-now-btn"
              className="ml-3 inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-2.5 rounded-full shadow-sm hover:shadow-md transition-all"
            >
              <Heart className="h-4 w-4 fill-white" /> Donate Now
            </button>
          </nav>

          <div className="flex items-center gap-2 lg:hidden">
            <button
              onClick={openDonate}
              data-testid="nav-donate-now-btn-mobile"
              className="inline-flex items-center gap-1.5 bg-emerald-600 text-white font-semibold px-3.5 py-2 rounded-full text-sm"
            >
              <Heart className="h-4 w-4 fill-white" /> Donate
            </button>
            <button
              onClick={() => setOpen(!open)}
              data-testid="nav-mobile-toggle"
              className="p-2 text-slate-700"
              aria-label="Toggle menu"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-1">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setOpen(false)}
              data-testid={`${item.testId}-mobile`}
              className="block px-4 py-3 rounded-lg text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
